var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13807 2.19526C5.39842 2.45561 5.39842 2.87772 5.13807 3.13807C4.87772 3.39842 4.45561 3.39842 4.19526 3.13807L3.33333 2.27614L3.33333 11.3333C3.33333 11.7015 3.03486 12 2.66667 12C2.29848 12 2 11.7015 2 11.3333L2 2.27614L1.13807 3.13807C0.877722 3.39842 0.455611 3.39842 0.195262 3.13807C-0.0650874 2.87772 -0.0650874 2.45561 0.195262 2.19526L2.19526 0.195262C2.45561 -0.0650874 2.87772 -0.0650873 3.13807 0.195262L5.13807 2.19526Z",
    fill: "#3D4744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 9.72386L7.80474 8.86193C7.54439 8.60158 7.12228 8.60158 6.86193 8.86193C6.60158 9.12228 6.60158 9.54439 6.86193 9.80474L8.86193 11.8047C9.12228 12.0651 9.54439 12.0651 9.80474 11.8047L11.8047 9.80474C12.0651 9.54439 12.0651 9.12228 11.8047 8.86193C11.5444 8.60158 11.1223 8.60158 10.8619 8.86193L10 9.72386L10 0.666667C10 0.298477 9.70153 1.50874e-07 9.33333 1.50874e-07C8.96515 1.50874e-07 8.66667 0.298477 8.66667 0.666667L8.66667 9.72386Z",
    fill: "#3D4744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.873c47b965d212a20a71ceeb4c92c11c.svg";
export { ForwardRef as ReactComponent };